import Immutable from 'immutable';
import { createMigration } from './utils';

/**
 * Alter the structure of the scene group data.
 */
export const migrationTo9_160 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            const groupIdToSceneGroup = new Map<string, { id: string; sceneIds: string[]; }>();

            // Create a mapping from sceneId -> sceneIndex, to be used to sort the sceneIds array in the scene group.
            const sceneIdToIndex = new Map<string, number>();
            map.get('slides').toJS().forEach((scene, index) => sceneIdToIndex.set(scene.id, index));

            map.get('sceneGroups').forEach((groupId: string, sceneId: string) => {
                let sceneGroup = groupIdToSceneGroup.get(groupId);
                if (!sceneGroup) {
                    sceneGroup = { id: groupId, sceneIds: [] };
                    groupIdToSceneGroup.set(groupId, sceneGroup);
                }
                sceneGroup.sceneIds.push(sceneId);
            });

            let sceneGroups = Array.from(groupIdToSceneGroup.values());

            // slide range slicing occurs before migration. Some scene ids are invalid, remove them.
            sceneGroups.forEach(sceneGroup => (sceneGroup.sceneIds = sceneGroup.sceneIds.filter(sceneId => sceneIdToIndex.get(sceneId) !== undefined)));
            sceneGroups = sceneGroups.filter(sceneGroup => sceneGroup.sceneIds.length > 0);

            // Since the ids were extracted from an object { sceneId: groupId }, the order is likely not correct, sorting is the final step.
            sceneGroups.forEach(sceneGroup => sceneGroup.sceneIds.sort((l, r) => sceneIdToIndex.get(l) - sceneIdToIndex.get(r)));
            sceneGroups.sort((l, r) => sceneIdToIndex.get(l.sceneIds[0]) - sceneIdToIndex.get(r.sceneIds[0]));

            map.set('sceneGroups', Immutable.fromJS(sceneGroups));
        });
    },
});
